import React from 'react';
import './scss/styles.scss';
import NavBar from './components/NavBar';
import TopBar from './components/TopBar';
import AuthenticationGuard from './components/AuthenticationGuard';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import PersonaDiscovery from './pages/PersonaDiscovery';
import SellMessagingCreator from './pages/SellMessagingCreator';

function App() {
  return (
    <div className='container-fluid min-width'>
      <AuthenticationGuard>
        <BrowserRouter>
          <div className='row m-0 p-0'>
            <div className='col-12 m-0 p-0'></div>
          </div>
          <div className='row m-0 p-0'>
            <div className='col-2  m-0 p-0 sidebar-col'>
              <NavBar />
            </div>
            <div className='col m-0 p-0 content-col'>
              <TopBar />
              <Routes>
                <Route
                  path='/PersonaDiscovery'
                  element={<PersonaDiscovery />}
                />
                <Route
                  path='/SellMessagingCreator'
                  element={<SellMessagingCreator />}
                />
                <Route path='/' element={<Navigate to='/PersonaDiscovery' />} />
              </Routes>
            </div>
          </div>
        </BrowserRouter>
      </AuthenticationGuard>
    </div>
  );
}

export default App;
